import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ProductsList from '~/containers/productsList/productsList';

export default class CustomersPage extends Component {
  render() {
    const createButton = (
      <Link to="/products/create">
        <Button color="primary">New Product</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar title="Products" button={createButton} />
        <ProductsList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/products.jsx